import { MDIcon } from "@cjdev-internal/visual-stack-x/MDIcon";
import React from "react";

export const WebsiteIcon = ({ ...restProps }) => (
  <span>
    <MDIcon icon="web" color="#49C5B1" {...restProps} />
  </span>
);
